export default __webpack_public_path__ + "static/media/misc-pantry3-1920w.a708c379.png";